import { handleActions } from 'redux-actions';
import actions from '../../actions/banner/reveal';

const INITIAL_STATE = {
    isVisible: false,
};

export default handleActions(
    {
        [actions.show]: (state, action) => {
            return {
                ...state,
                isVisible: true,
                addedProduct: action.payload,
            }
        },
        [actions.hide]: (state, action) => {
            return {
                ...state,
                isVisible: false,
                ...action.payload
            }
        }
    },
    { ...INITIAL_STATE },
);
